import { cn } from "@/lib/utils";
import { Scribbles } from "@somethings-ui/core/assets";
import { colorsV2 } from "@somethings-ui/core";
import type { CSSProperties, ReactNode } from "react";

interface PeriwinkleCardProps {
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
  variant?: "highlight" | "solid";
  cloudSource?: string;
}

export function PeriwinkleCard({
  className,
  style,
  children,
  variant = "solid",
  cloudSource = Scribbles.periwinkleCloud,
}: PeriwinkleCardProps) {
  const isHighlight = variant === "highlight";
  return (
    <div
      className={cn("relative overflow-hidden", className)}
      style={{
        backgroundColor: isHighlight
          ? colorsV2.brand.periwinkleDark
          : colorsV2.brand.periwinkle,
        ...style,
      }}
    >
      <img
        src={cloudSource}
        alt=""
        aria-hidden
        className="pointer-events-none absolute inset-0 h-full w-full select-none object-cover"
        style={{
          opacity: isHighlight ? 0.95 : 0.6,
          transform: "rotate(15deg) scale(1.35)",
        }}
      />
      <div className="relative h-full">{children}</div>
    </div>
  );
}
